<template>
  <v-expansion-panel
    static
    class="e-expansion-panel"
    :class="{ 'e-expansion-panel-with-title-secondary': slots.titleSecondary }"
  >
    <template v-if="slots.title" #title>
      <div class="w-100">
        <div class="d-flex align-center">
          <b class="paragraph-l">
            <slot name="title" />
          </b>
          <e-icon name="arrowDropdown" :size="10" class="ml-3 e-expansion-panel__icon" />
        </div>
        <div v-if="slots.titleSecondary" class="mt-2">
          <slot name="titleSecondary" />
        </div>
      </div>
    </template>
    <template #text>
      <slot />
    </template>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { EIcon } from '@/core/components/ui';

const slots = defineSlots<{
  default: (props: unknown) => void;
  title?: (props: unknown) => void;
  titleSecondary?: () => void;
}>();
</script>

<style scoped lang="scss">
.e-expansion-panel {
  margin-top: 0 !important;

  border-radius: 0;
  box-shadow: none;

  &__icon {
    transform: rotate(180deg);
    transition: transform $transition-duration;
  }

  &:not(.v-expansion-panel--active) {
    .e-expansion-panel__icon {
      transform: rotate(0);
    }
  }

  &:after {
    display: none;
  }

  &.e-expansion-panel-with-title-secondary {
    :deep(.v-expansion-panel-title) {
      width: 100%;
    }
  }

  :deep(.v-expansion-panel-title) {
    justify-content: flex-start;

    width: fit-content;
    min-height: initial;
    padding: 12px 0;

    font-size: initial;
    color: $text-primary-color;

    transition: color $transition-duration;

    @include hover {
      color: $text-secondary-color;
    }

    @include sm-and-down {
      padding: 8px 0;
    }
  }

  :deep(.v-expansion-panel-title__icon) {
    i {
      display: none;
    }
  }

  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }

  :deep(.v-expansion-panel-title__overlay) {
    display: none;
  }

  :deep(.v-expansion-panel__shadow) {
    display: none;
  }
}
</style>
